<template>
  
</template>

<script>
import Utils from "@/services/utils";

export default {
  created() {
    const redirect = this.$route.params.redirectTo;
    const accessToken = window.V.$localStorage.get("ACCESS_TOKEN");
    const refreshToken = window.V.$localStorage.get("REFRESH_TOKEN");
    const lang = window.V.$localStorage.get("bpz_lang");
    const queryParams = `?access_token=${accessToken}&refresh_token=${refreshToken}&lang=${lang}`;
    window.location.href = `${Utils.getDevantBaseUrl()}/${redirect}${queryParams}`
  }
}
</script>
